/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { adjustStockHead } from "../../../../../config/constant";
import {
    capitalizeFirstLetter, checkCRUDPermission,
    getColumnWidth, idNamingConversion
} from "../../../../../helpers/utilities";
import SearchText from '../../../../Shared/components/SearchText';
import { AESEncrypt } from "../../../../../helpers/Crypto";
import moment from 'moment';
import { Image, Space } from "antd";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import DeleteModal from "../../../../Shared/components/DeleteModal";


export const ListTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, loadTasks, loadMore, loadMoreTask, loadMoreContent, roleManagement, search } = props;
    const [quoteId, setQuoteId] = useState('');
    const [quoteDeleteId, setQuoteDeleteId] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);

    const onDelete = (data) => {
        setDeleteModal(true);
        setQuoteId(data?.serialNo);
        setQuoteDeleteId(data?.id);
    }


    const classes = customStyles();
    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={adjustStockHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                details={details}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={adjustStockHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i} >
                                                <TableCell style={{ width: getColumnWidth(adjustStockHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Stock Count', 'view', 'Product') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'stockCount', 'Link')} style={{ width: getColumnWidth(adjustStockHead, 0) }} to={`/product/inventory/stock-count/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.bold)}>{data?.serialNo || '---'}</Link> : <span style={{ width: getColumnWidth(adjustStockHead, 0) }}>{data?.serialNo || '---'}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(adjustStockHead, 1) }}><span style={{ width: getColumnWidth(adjustStockHead, 1) }} >{data?.createTs ? moment(data?.createTs).format('DD MMM YYYY') : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(adjustStockHead, 2) }}><span style={{ width: getColumnWidth(adjustStockHead, 2) }} >{data?.updateTs ? moment(data?.updateTs).format('DD MMM YYYY') : '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(adjustStockHead, 3) }}><span style={{ width: getColumnWidth(adjustStockHead, 3) }} >{data?.createdByUser?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(adjustStockHead, 4) }}><span style={{ width: getColumnWidth(adjustStockHead, 4) }} >{data?.updatedByUser?.name || '---'}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(adjustStockHead, 7) }}>
                                                    <div className={clsx(classes.statusButton,
                                                        { [classes.confirmedButton]: data.countStatus === 'CONFIRMED' })}>{capitalizeFirstLetter(data.countStatus)}</div>
                                                </TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding, classes.actionWidth)}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Stock Count', 'view', 'Product') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'stockCount', 'Icon')} to={`/product/inventory/stock-count/${AESEncrypt(data.id)}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Stock Count', 'edit', 'Product') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'stockCount', 'Icon')} to={`/product/inventory/stock-count/${AESEncrypt(data.id)}/edit`}
                                                                className={clsx({
                                                                    [classes.disabled]: data.countStatus === 'CONFIRMED'
                                                                })}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Stock Count', 'deletable', 'Product') &&
                                                            <NavLink to={"#"} className={clsx({
                                                                [classes.disabled]: (data.countStatus === 'CONFIRMED')
                                                            })}
                                                                id={idNamingConversion('Delete_' + data.id, 'stockCount', 'Icon')}
                                                                onClick={() => onDelete(data)}>
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={adjustStockHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> :
                                                            <p style={{ lineHeight: 2 }} className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'All Stock Count will be listed here.'}</p>

                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </Fragment>
                            )
                        }
                    </>
                }
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={quoteDeleteId} loadTasks={() => loadTasks()}
                name={quoteId} url={'stockCount'} title={'Stock Count'} visible={deleteModal} />

        </>
    )
}